import { Autocomplete, TextField } from "@mui/material";
import { useMemo } from "react";

export function YearAutocompletePicker({
  minYear = 1980,
  maxYear = new Date().getFullYear(),
  label = "Year",
  value,
  onChange,
}: {
  minYear?: number;
  maxYear?: number;
  label?: string;
  value: number;
  onChange: (year: number) => void;
}) {
  const yearOptions = useMemo(
    () => Array.from({ length: maxYear - minYear + 1 }, (_, i) => maxYear - i),
    [minYear, maxYear]
  );

  return (
    <Autocomplete<number, false, true, false>
      options={yearOptions}
      value={value}
      onChange={(_, value) => onChange(value)}
      getOptionLabel={(option) => option.toString()}
      renderInput={(params) => <TextField {...params} label={label} variant="standard" />}
      disableClearable
    />
  );
}
